// @mui
import { Stack, Button, Typography, Box } from "@mui/material";
// hooks
import useAuth from "../../../hooks/useAuth";
import { useTranslation } from "react-i18next";
// motion
import { m } from "framer-motion";

// ----------------------------------------------------------------------

export default function NavbarDocs() {
  const { user } = useAuth();
  const { t } = useTranslation();

  return (
    <Stack
      spacing={3}
      sx={{
        px: 5,
        pt: 0.5,
        pb: 3,
        width: 1,
        textAlign: "center",
        display: "block",
      }}
    >
      <Stack sx={{ display: "flex", alignItems: "center" }}>
        <Box
          component={m.img}
          src="/static/logo/logo.png"
          alt="mascot"
          sx={{ height: 140, mb: 1 }}
          initial={{ opacity: 0, scale: 0.9, y: 10 }}
          animate={{
            opacity: 1,
            scale: 1,
            y: [0, -6, 0],
          }}
          transition={{
            duration: 0.8,
            ease: "easeOut",
            y: {
              duration: 3,
              repeat: Infinity,
              repeatType: "mirror",
              ease: "easeInOut",
            },
          }}
          whileHover={{
            scale: 1.06,
            rotate: -2,
            transition: { duration: 0.25 },
          }}
        />

        <Typography variant="subtitle1">
          {t("params.hi")} {user?.username} !
        </Typography>

        <Typography variant="body2" sx={{ color: "text.secondary", pb: 1 }}>
          {t("params.need_help")}
        </Typography>

        <Button
          href="https://wa.me/+56957540283"
          target="_blank"
          rel="noopener"
          variant="contained"
        >
          {t("params.contactus")}
        </Button>
      </Stack>
    </Stack>
  );
}
